import axios from 'axios';

function createCartButtonClickedEvent(): void {
    navigator.sendBeacon(`${axios.defaults.baseURL as string}/api/event/cart-button-clicked`);
}

export { createCartButtonClickedEvent };
